<template>
  <div id="app">
    <el-container>
      <!-- 头部栏 -->
      <el-header>
        <div class="logo">
          <img src="./assets/img/layout/nav_logo.png" alt />
          <div class="logo-title">
            <span class="">广州市富尔菱自动化系统有限公司</span>
          </div>
        </div>
        <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          :router="router"
          text-color="#303133"
          active-text-color="#0f87ff"
        >
          <el-menu-item index="/">首页</el-menu-item>
          <!-- <el-menu-item index="/product">产品中心</el-menu-item> -->
          <el-submenu index="/product">
            <template slot="title">产品中心</template>
            <el-menu-item index="/product?id=1">柔性物流输送系统</el-menu-item>
            <el-menu-item index="/product?id=2">自动装箱机</el-menu-item>
            <el-menu-item index="/product?id=3">机器人码垛系统</el-menu-item>
            <el-menu-item index="/product?id=4">智能仓储系统</el-menu-item>
            <el-menu-item index="/product?id=5">机器人AGV</el-menu-item>
            <!-- <el-menu-item index="/product?id=6">复合移动机器人</el-menu-item>
            <el-menu-item index="/product?id=7">螺旋塔</el-menu-item>
            <el-menu-item index="/product?id=8">提升机</el-menu-item> -->
            <el-menu-item index="/product?id=9">标准柔性输送链</el-menu-item>
          </el-submenu>

          <!-- <el-menu-item index="/case">经典案例</el-menu-item> -->
          <el-menu-item index="/serve">服务中心</el-menu-item>
          <!-- <el-menu-item index="/news">新闻资讯</el-menu-item> -->
          <el-menu-item index="/goin">走进富尔菱</el-menu-item>
          <!-- <el-menu-item index="/download">下载APP</el-menu-item> -->
        </el-menu>

        <div class="language">
          <el-dropdown @command="switchLanguage">
            <span class="el-dropdown-link">
              {{ Language == "zh-CN" ? "中文" : "English"
              }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="zh-CN">中文</el-dropdown-item>
              <el-dropdown-item command="en-US">English</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>

      <!-- 内容 -->
      <el-main>
        <router-view />
      </el-main>

      <!-- 页底 -->
      <div class="footer" v-show="isShow">
        <div class="footer-content">
          <ul class="content-nav">
            <!-- <li>
              <p>走进科建</p>
              <span>发展历程</span>
              <span>企业文化</span>
              <span>资质荣誉</span>
              <span>合作伙伴</span>
            </li> -->
            <li>
              <p>新闻资讯</p>
              <span>公司新闻</span>
              <span>行业动态</span>
            </li>
            <!-- <li>
              <p>产品中心</p>
              <span>介绍视频</span>
              <span>管理模式</span>
              <span>平台目标</span>
              <span>功能模块</span>
            </li> -->
            <li>
              <p>联系我们</p>
              <!-- 热线号码已精简：去除第二个号码"82227179"，并删除传真行 -->
              <span>热线：020-82217633</span>
              <span>邮箱：Linda.liu@gzfullink.com</span>
              <span>地址：广州市黄埔区埔南路63号之中2号厂房一层</span>
            </li>
          </ul>
          <!-- 新增：版权和备案信息区域，位于二维码左侧 -->
          <div class="footer-icp-info">
            <p>Copyright © 2026 广州市富尔菱自动化系统有限公司 版权所有</p>
            <p class="icp-link-container">
              <a href="https://beian.miit.gov.cn/" target="_blank" class="icp-link">
                <img src="https://www.gdzwfw.gov.cn/portal/static/images/components/footer/beian.png" alt="备案图标" class="beian-icon" />
                粤ICP备17083762号
              </a>
            </p>
          </div>
          <img src="./assets/img/weChat.jpg" alt class="wechat-img" />
        </div>
        <div class="copyright">
          <span>富尔菱版权所有</span>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
import { setLang, getLang } from "@/utils/lang";

export default {
  data() {
    return {
      router: true,
      defaultActive: "/product?id=4",
      isShow: true,

      Language: "",
    };
  },
  computed: {
    text: function () {
      return {
        n: this.$t("headName"),
      };
    },
  },
  created() {
    this.Language = getLang() || "zh-CN";
  },
  methods: {
    handleSelect(key) {
      // this.isShow = this.defaultActive != key;
      // window.console.log(this.isShow);
    },
    switchLanguage(command) {
      console.log(command, "switchLanguage");
      setLang(command);
      setTimeout(() => {
        this.$router.go(0);
      }, 500);
    },
  },

  watch: {
    $route: {
      handler(newRoute) {
        console.log(newRoute, this.defaultActive, "newRoute");
        this.isShow = newRoute.fullPath != "/";
        this.defaultActive = newRoute.fullPath;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
.el-menu--horizontal .el-menu .el-menu-item:hover {
  background: #9accfe !important;
  color: #0011ff !important;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 100%;
  // width: 1240px;
  margin: 0 auto;

  position: sticky;
  left: 0;
  top: 0;
  z-index: 999;
  background-color: #fff;

  .logo {
    width: 450px;
    height: 100%;
    @include row-c;
    column-gap: 10px;
    // padding: 10px;
    img {
      width: 60px;
      height: 60px;
    }
    .logo-title {
      @include col-c;
      row-gap: 2px;
      font-size: 24px;
      font-family: "阿里楷体";
      align-items: flex-start;
      // color: $themeColor;
      color: $headThemeColor;
      text-shadow: 1px 1px 2px rgb(228, 215, 73);
    }
  }
  .el-menu-demo {
    margin-right: 80px;
  }
  .language {
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translate(0%, -50%);
  }
}
.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  height: 216px;
  // position: sticky;
  // left: 0;
  // bottom: 0;
  overflow: hidden;
  background-color: #14679f;
  &-content {
    width: 1240px;
    margin: 0 auto;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    .content-nav {
      display: flex;
      justify-content: space-around;
      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        //justify-content: center;
        align-items: flex-start;
        p {
          font-size: 20px;
          color: #d4edff;
          padding: 10px 0;
        }
        span {
          color: #f7f7f7;
          font-weight: 300;
          padding: 5px 0;
        }
      }
    }
    /* 新增：底部版权和备案信息样式，居中于左侧内容和右侧二维码之间 */
    .footer-icp-info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start; /* 优化：使容器内的两行p标签互相左对齐 */
      margin-left: auto; /* 配合 flex-start 依然能整体靠右侧微信二维码 */
      padding-right: 20px;
      color: #f7f7f7;
      font-size: 14px;
      line-height: 24px;
      p {
        margin: 5px 0;
      }
      .icp-link-container {
        display: flex;
        align-items: center;
      }
      .icp-link {
        color: #f7f7f7;
        text-decoration: none;
        display: flex;
        align-items: center;
        transition: color 0.3s;
        &:hover {
          color: #d4edff;
        }
      }
      .beian-icon {
        width: 16px !important;
        height: 16px !important;
        padding: 0 !important;
        margin-right: 6px;
      }
    }
    img.wechat-img {
      width: 170px;
      height: 170px;
      padding: 10px;
    }
  }
  .copyright {
    height: 30px;
    background: #125688;
    span {
      color: #fff;
      line-height: 30px;
    }
  }
}
</style>
